.sectionWrapper {
  display: flex;
  flex-wrap: wrap;
}
